import React, {useState} from 'react';

import {hooks} from '../hooks';
import {items} from '../items';
import {ActivitiesType} from '../types';
import {Routes} from '../routes';
import {components} from '../components';


export const Activities: React.FC = () => {
  const dispatch = hooks.useDispatch();

  const navigate = hooks.useNavigate();
  const {activitiesLoading, activities} = hooks.useGetActivities();

  const location = hooks.useLocation();

  const [opacity, setOpacity] = useState<number>(0);
  
  hooks.useScrollToTop();
  hooks.useOpacity(setOpacity);
  hooks.useThemeColor('#F6F9F9', '#F6F9F9', dispatch);

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        title='Activities'
        showGoBack={true}
      />
    );
  };
  const renderContent = (): JSX.Element | null => {
    if (
      activitiesLoading ||
      activities.length === 0
    ) {
      return null;
    }

    return (
      <main className='scrollable container'>
        <ul style={{paddingTop: 10, paddingBottom: 20}}>
          {activities.map(
            (activity: ActivitiesType, index: number, array: ActivitiesType[]) => {
              const isLast = index === array.length - 1;

              return (
                <items.ActivitiesItem
                  activity={activity}
                  index={index}
                  key={activity.id}
                  isLast={isLast}
                />
              );
            },
          )}
        </ul>
      </main>
    );
  };

  const renderLoader = (): JSX.Element | null => {
    if (
      activitiesLoading ||
      activities.length === 0
    ) {
      return <components.Loader />;
    }
    return null;
  };
  
  const renderFooter = (): JSX.Element => {
    return <components.Footer />;
  };

  return (
    <div
      id='screen'
      style={{opacity}}
    >
      {renderHeader()}
      {renderContent()}
      {renderLoader()}
      {renderFooter()}
    </div>
  );
};
